import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1115aefe")

_pushScopeId("data-v-1115aefe")
const _hoisted_1 = { class: "follow-up-panel" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_3 = { class: "fw-semibold fs-7" }
const _hoisted_4 = { class: "form-check form-switch form-check-custom form-check-solid mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "badge badge-light-secondary mt-2"
}
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "form-label required" }, "Scenario name", -1)
const _hoisted_8 = { class: "text-muted fs-7 mb-5" }
const _hoisted_9 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_10 = { class: "mb-0 d-inline-flex align-items-center gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-muted fs-8 fw-normal"
}
const _hoisted_12 = { class: "d-flex align-items-center gap-2" }
const _hoisted_13 = { class: "svg-icon svg-icon-3" }
const _hoisted_14 = { class: "d-flex align-items-center gap-3 mb-4" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { class: "form-label mb-0" }, "Send after", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("option", { value: "minutes" }, "Minutes", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("option", { value: "hours" }, "Hours", -1)
const _hoisted_18 = { class: "form-check form-check-custom form-check-solid mb-4" }
const _hoisted_19 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Optional hint for AI", -1)
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Images or video (optional)", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-3" }, " Attach up to 4 images or videos from your media library. ", -1)
const _hoisted_24 = { class: "d-flex flex-wrap align-items-center gap-2 mb-3" }
const _hoisted_25 = {
  key: 0,
  class: "alert alert-warning mt-6 mb-0 fs-7"
}
const _hoisted_26 = { class: "email-continuation-section" }
const _hoisted_27 = /*#__PURE__*/_createVNode("h6", { class: "mb-4" }, "Email continuation", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-7 mb-4" }, " When Messenger, Instagram, or WhatsApp can no longer deliver automated follow-ups, remaining steps can continue by email if the contact has an address on file. ", -1)
const _hoisted_29 = { class: "form-check form-check-custom form-check-solid mb-4" }
const _hoisted_30 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "continueOnEmail"
}, " Continue on email when the messaging window closes ", -1)
const _hoisted_31 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid mb-4 ms-4"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "includeColdLeads"
}, " Also email Cold leads ", -1)
const _hoisted_33 = {
  key: 1,
  class: "text-muted fs-8 mb-4"
}
const _hoisted_34 = {
  key: 2,
  class: "alert alert-warning fs-7 mb-0"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Email continuation works best when contacts have an address. Consider enabling ")
const _hoisted_36 = /*#__PURE__*/_createVNode("strong", null, "Ask for email", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" under Options → Contact Update, or ensure addresses are already on the contact record. ")
const _hoisted_38 = { class: "alert alert-light-info d-flex align-items-start mt-6 mb-0" }
const _hoisted_39 = { class: "svg-icon svg-icon-2hx svg-icon-info me-4 mt-1" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"fs-7\" data-v-1115aefe><strong data-v-1115aefe>Staying within platform rules</strong><ul class=\"mb-0 mt-2 ps-4\" data-v-1115aefe><li data-v-1115aefe><strong data-v-1115aefe>Facebook &amp; Instagram:</strong> Automated messages must fall within 20 hours of the customer&#39;s last message.</li><li data-v-1115aefe><strong data-v-1115aefe>WhatsApp:</strong> Similar 20-hour session window.</li><li data-v-1115aefe><strong data-v-1115aefe>SMS:</strong> Follow-ups are rate-limited to reduce spam risk.</li><li data-v-1115aefe><strong data-v-1115aefe>Email continuation:</strong> Not limited by the 20-hour social window. Prospects can reply to the email to continue the conversation.</li><li data-v-1115aefe>Sequences cancel when the contact replies or you take over manually.</li></ul></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_ContentMediaLibrary = _resolveComponent("ContentMediaLibrary")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scenarioItems, (item) => {
      return (_openBlock(), _createBlock("div", {
        key: item.key,
        class: ["scenario-item scenario-item--compact mb-5", {
        active: _ctx.selectedScenario === item.key,
        disabled: item.disabled
      }],
        onClick: ($event: any) => (_ctx.selectScenario(item))
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode("input", {
              id: `scenario-${item.key}`,
              "onUpdate:modelValue": ($event: any) => (_ctx.scenarios[item.key].enabled = $event),
              class: "form-check-input",
              type: "checkbox",
              disabled: item.disabled || _ctx.readonly,
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              onChange: ($event: any) => (_ctx.onScenarioEnabledChange(item.key))
            }, null, 40, ["id", "onUpdate:modelValue", "disabled", "onChange"]), [
              [_vModelCheckbox, _ctx.scenarios[item.key].enabled]
            ])
          ])
        ]),
        (item.disabled)
          ? (_openBlock(), _createBlock("span", _hoisted_5, "Coming soon"))
          : _createCommentVNode("", true)
      ], 10, ["onClick"]))
    }), 128)),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeScenario.name = $event)),
          type: "text",
          class: "form-control form-control-solid",
          disabled: _ctx.readonly || !_ctx.activeScenario.enabled,
          required: ""
        }, null, 8, ["disabled"]), [
          [_vModelText, _ctx.activeScenario.name]
        ])
      ]),
      _createVNode("p", _hoisted_8, "Configure up to " + _toDisplayString(_ctx.maxFollowUpSteps) + " follow-ups", 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeScenario.steps, (step, index) => {
        return (_openBlock(), _createBlock("div", {
          key: `${_ctx.selectedScenario}-${index}`,
          class: "step-card mb-5"
        }, [
          _createVNode("div", _hoisted_9, [
            _createVNode("button", {
              type: "button",
              class: "step-card__heading btn btn-link btn-color-gray-800 p-0 text-start",
              onClick: ($event: any) => (_ctx.toggleStepCollapsed(index))
            }, [
              _createVNode("h6", _hoisted_10, [
                _createVNode("i", {
                  class: ["fas fa-chevron-down step-card__chevron", { 'step-card__chevron--collapsed': _ctx.isStepCollapsed(index) }]
                }, null, 2),
                _createTextVNode(" Follow-up " + _toDisplayString(index + 1) + " ", 1),
                (_ctx.isStepCollapsed(index))
                  ? (_openBlock(), _createBlock("span", _hoisted_11, " · after " + _toDisplayString(_ctx.getDelayDisplayValue(step)) + " " + _toDisplayString(_ctx.getStepDelayUnit(step)), 1))
                  : _createCommentVNode("", true)
              ])
            ], 8, ["onClick"]),
            _createVNode("div", _hoisted_12, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-icon btn-light",
                title: _ctx.isStepCollapsed(index) ? 'Expand' : 'Collapse',
                onClick: ($event: any) => (_ctx.toggleStepCollapsed(index))
              }, [
                _createVNode("i", {
                  class: ["fas fa-chevron-down step-card__chevron", { 'step-card__chevron--collapsed': _ctx.isStepCollapsed(index) }]
                }, null, 2)
              ], 8, ["title", "onClick"]),
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-icon btn-light-danger",
                disabled: _ctx.readonly || !_ctx.activeScenario.enabled,
                onClick: ($event: any) => (_ctx.removeStep(index))
              }, [
                _createVNode("span", _hoisted_13, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Trash.svg" })
                ])
              ], 8, ["disabled", "onClick"])
            ])
          ]),
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode("input", {
                value: _ctx.getDelayDisplayValue(step),
                type: "number",
                min: _ctx.delayInputMin(_ctx.getStepDelayUnit(step)),
                max: _ctx.delayInputMax(_ctx.getStepDelayUnit(step)),
                class: "form-control form-control-solid w-100px",
                disabled: _ctx.readonly || !_ctx.activeScenario.enabled,
                onInput: ($event: any) => (_ctx.onDelayValueChange(step, $event))
              }, null, 40, ["value", "min", "max", "disabled", "onInput"]),
              _createVNode("select", {
                class: "form-select form-select-solid w-auto",
                value: _ctx.getStepDelayUnit(step),
                disabled: _ctx.readonly || !_ctx.activeScenario.enabled,
                onChange: ($event: any) => (_ctx.onDelayUnitChange(step, $event))
              }, [
                _hoisted_16,
                _hoisted_17
              ], 40, ["value", "disabled", "onChange"])
            ]),
            _createVNode("div", _hoisted_18, [
              _withDirectives(_createVNode("input", {
                id: `useLlm-${_ctx.selectedScenario}-${index}`,
                "onUpdate:modelValue": ($event: any) => (step.useLlm = $event),
                class: "form-check-input",
                type: "checkbox",
                disabled: _ctx.readonly || !_ctx.activeScenario.enabled,
                onChange: ($event: any) => (_ctx.onUseLlmChange(step))
              }, null, 40, ["id", "onUpdate:modelValue", "disabled", "onChange"]), [
                [_vModelCheckbox, step.useLlm]
              ]),
              _createVNode("label", {
                class: "form-check-label",
                for: `useLlm-${_ctx.selectedScenario}-${index}`
              }, " Let AI Send The Message ", 8, ["for"])
            ]),
            (step.useLlm)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createVNode("textarea", {
                    "onUpdate:modelValue": ($event: any) => (step.llmHint = $event),
                    class: "form-control form-control-solid",
                    rows: "2",
                    placeholder: "Optional guidance for the follow-up tone or content…",
                    disabled: _ctx.readonly || !_ctx.activeScenario.enabled
                  }, null, 8, ["onUpdate:modelValue", "disabled"]), [
                    [_vModelText, step.llmHint]
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_21, [
                  _createVNode("label", {
                    class: ["form-label", { required: !_ctx.hasStepMedia(step) }]
                  }, "Message", 2),
                  _withDirectives(_createVNode("textarea", {
                    "onUpdate:modelValue": ($event: any) => (step.message = $event),
                    class: "form-control form-control-solid mb-3",
                    rows: "3",
                    placeholder: "Write the follow-up message…",
                    disabled: _ctx.readonly || !_ctx.activeScenario.enabled,
                    required: !_ctx.hasStepMedia(step)
                  }, null, 8, ["onUpdate:modelValue", "disabled", "required"]), [
                    [_vModelText, step.message]
                  ]),
                  (_ctx.agentId)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-sm btn-light-primary mb-4",
                        disabled: _ctx.generatingIndex === index || _ctx.readonly || !_ctx.activeScenario.enabled,
                        onClick: ($event: any) => (_ctx.generateMessage(index))
                      }, _toDisplayString(_ctx.generatingIndex === index ? "Generating…" : "Generate with AI"), 9, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  _hoisted_22,
                  _hoisted_23,
                  _createVNode("div", _hoisted_24, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light-primary",
                      disabled: _ctx.readonly || !_ctx.activeScenario.enabled || _ctx.uploadingStepIndex === index,
                      onClick: ($event: any) => (_ctx.openFollowUpUpload(index))
                    }, _toDisplayString(_ctx.uploadingStepIndex === index ? "Uploading…" : "Upload image or video"), 9, ["disabled", "onClick"])
                  ]),
                  (_ctx.activeScenario.enabled)
                    ? (_openBlock(), _createBlock(_component_ContentMediaLibrary, {
                        key: 1,
                        ref: (el) => _ctx.setStepMediaLibraryRef(index, el),
                        "selected-ids": _ctx.stepMediaIds(step),
                        "max-selection": 4,
                        "read-only": _ctx.readonly || !_ctx.activeScenario.enabled,
                        "onUpdate:selectedIds": ($event: any) => (_ctx.updateStepMediaIds(index, $event))
                      }, null, 8, ["selected-ids", "read-only", "onUpdate:selectedIds"]))
                    : _createCommentVNode("", true)
                ]))
          ], 512), [
            [_vShow, !_ctx.isStepCollapsed(index)]
          ])
        ]))
      }), 128)),
      _createVNode("input", {
        ref: "followUpUploadInput",
        type: "file",
        accept: "image/*,video/*",
        class: "d-none",
        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFollowUpFileSelected && _ctx.onFollowUpFileSelected(...args)))
      }, null, 544),
      _createVNode("button", {
        type: "button",
        class: "btn btn-link btn-color-primary p-0",
        disabled: _ctx.readonly || !_ctx.activeScenario.enabled || _ctx.activeScenario.steps.length >= _ctx.maxFollowUpSteps,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addStep && _ctx.addStep(...args)))
      }, " + Add Follow-up ", 8, ["disabled"]),
      (_ctx.windowWarning)
        ? (_openBlock(), _createBlock("div", _hoisted_25, _toDisplayString(_ctx.windowWarning), 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_26, [
        _hoisted_27,
        _hoisted_28,
        _createVNode("div", _hoisted_29, [
          _createVNode("input", {
            id: "continueOnEmail",
            class: "form-check-input",
            type: "checkbox",
            checked: _ctx.followUpOptions.continueOnEmail,
            disabled: _ctx.readonly,
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setFollowUpOption('continueOnEmail', ($event.target as _ctx.HTMLInputElement).checked)))
          }, null, 40, ["checked", "disabled"]),
          _hoisted_30
        ]),
        (_ctx.followUpOptions.continueOnEmail)
          ? (_openBlock(), _createBlock("div", _hoisted_31, [
              _createVNode("input", {
                id: "includeColdLeads",
                class: "form-check-input",
                type: "checkbox",
                checked: _ctx.followUpOptions.includeColdLeads,
                disabled: _ctx.readonly,
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setFollowUpOption('includeColdLeads', ($event.target as _ctx.HTMLInputElement).checked)))
              }, null, 40, ["checked", "disabled"]),
              _hoisted_32
            ]))
          : _createCommentVNode("", true),
        (_ctx.followUpOptions.continueOnEmail && !_ctx.followUpOptions.includeColdLeads)
          ? (_openBlock(), _createBlock("p", _hoisted_33, " By default, only Hot and Warm leads receive email follow-ups. "))
          : _createCommentVNode("", true),
        (_ctx.askForEmailWarning)
          ? (_openBlock(), _createBlock("div", _hoisted_34, [
              _hoisted_35,
              _hoisted_36,
              _hoisted_37
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_38, [
        _createVNode("span", _hoisted_39, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
        ]),
        _hoisted_40
      ])
    ])
  ]))
})